import authService from './auth.service';

export type AlertSeverity = 'high' | 'medium' | 'low';

export interface ConfigAlert {
  severity: AlertSeverity;
  area: string;
  code: string;
  title: string;
  detail: string;
  /** Where it is fixed: the system and its screen. */
  fixed_in?: string | null;
  /** The portal address of that screen, when it is the portal's. */
  fix_path?: string | null;
  needs_second_person?: boolean;
}

export interface ConfigHealth {
  alerts: ConfigAlert[];
  checks_run: number;
}

class ConfigHealthService {
  /** Run the super-admin configuration health checks and return any alerts. */
  async get(): Promise<ConfigHealth> {
    const res = await authService.getApi().get<ConfigHealth>('/api/v1/admin/config-health');
    return res.data;
  }
}

export default new ConfigHealthService();
